import React from 'react';
import './CustomerToolbar.css';
import SharedSearchInput from '../../../../components/shared/SharedSearchInput/SharedSearchInput';

/**
 * Toolbar for searching, filtering and toggling view mode.
 */
export default function CustomerToolbar({ 
    searchTerm, 
    setSearchTerm, 
    statusFilter, 
    setStatusFilter, 
    viewMode, 
    setViewMode,
    onAdd
}) {
    return (
        <div className="customer-toolbar">
            <div className="toolbar-left">
                <div className="search-wrapper">
                    <SharedSearchInput
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        placeholder="Kunden suchen..."
                        onClear={() => setSearchTerm('')}
                    />
                </div>

                <div className="status-filter-group">
                    <button 
                        className={`filter-btn ${statusFilter === 'all' ? 'active' : ''}`}
                        onClick={() => setStatusFilter('all')}
                    >
                        Alle
                    </button>
                    <button 
                        className={`filter-btn ${statusFilter === 'aktiv' ? 'active' : ''}`}
                        onClick={() => setStatusFilter('aktiv')}
                    >
                        Aktiv
                    </button>
                    <button 
                        className={`filter-btn ${statusFilter === 'inaktiv' ? 'active' : ''}`}
                        onClick={() => setStatusFilter('inaktiv')}
                    >
                        Inaktiv
                    </button>
                </div>
            </div>

            <div className="toolbar-right">
                <div className="view-toggle">
                    <button 
                        className={`view-btn ${viewMode === 'list' ? 'active' : ''}`}
                        onClick={() => setViewMode('list')}
                        title="Listenansicht"
                    >
                        ☰
                    </button>
                    <button 
                        className={`view-btn ${viewMode === 'tile' ? 'active' : ''}`}
                        onClick={() => setViewMode('tile')}
                        title="Kachelansicht"
                    >
                        田
                    </button>
                </div>

                <button className="btn-primary add-btn" onClick={onAdd}>
                    <span className="add-icon">+</span> Kunde hinzufügen
                </button>
            </div>
        </div>
    );
}
